import { render, staticRenderFns } from "./indexManage-h.vue?vue&type=template&id=3fed6a97&scoped=true&"
import script from "./indexManage-h.vue?vue&type=script&lang=js&"
export * from "./indexManage-h.vue?vue&type=script&lang=js&"
import style0 from "./indexManage-h.vue?vue&type=style&index=0&id=3fed6a97&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fed6a97",
  null
  
)

export default component.exports